import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useGarden } from '../context/GardenContext'
import ShoppingList from '../components/ShoppingList'
import ToDoList from '../components/ToDoList'

type Tab = 'shopping' | 'todo'

export default function Lists() {
  const { state } = useGarden()
  const navigate = useNavigate()
  const [tab, setTab] = useState<Tab>('shopping')

  const totalPlants = new Set(state.containers.flatMap(c => c.plantIds)).size
  const hasContent = totalPlants > 0 || state.savedPlantIds.length > 0

  return (
    <div className="max-w-2xl mx-auto px-4 py-8 space-y-6 page-enter">
      <div className="text-center space-y-2">
        <h1 className="font-pixel text-ac-brown text-base">📋 Your Lists</h1>
        {hasContent ? (
          <p className="font-body text-ac-brown-light text-sm">
            {totalPlants} plant{totalPlants !== 1 ? 's' : ''} across {state.containers.length} container{state.containers.length !== 1 ? 's' : ''}
            {state.savedPlantIds.length > 0 ? ` · ${state.savedPlantIds.length} wishlisted` : ''}
          </p>
        ) : (
          <p className="font-body text-ac-brown-light text-sm">
            Add plants to your containers to generate your lists.
          </p>
        )}
      </div>

      {/* Tab switcher */}
      <div className="flex rounded-xl border-2 border-ac-brown overflow-hidden shadow-ac-sm">
        <button
          className={`flex-1 py-2 font-body font-bold text-sm transition-all
            ${tab === 'shopping' ? 'bg-ac-green text-ac-cream' : 'bg-ac-cream text-ac-brown hover:bg-ac-bg'}`}
          onClick={() => setTab('shopping')}
        >
          🛒 Shopping List
        </button>
        <button
          className={`flex-1 py-2 font-body font-bold text-sm transition-all border-l-2 border-ac-brown
            ${tab === 'todo' ? 'bg-ac-green text-ac-cream' : 'bg-ac-cream text-ac-brown hover:bg-ac-bg'}`}
          onClick={() => setTab('todo')}
        >
          📋 Care Schedule
        </button>
      </div>

      {tab === 'shopping' ? <ShoppingList /> : <ToDoList />}

      {!hasContent && (
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <button className="ac-btn-yellow" onClick={() => navigate('/browse')}>
            🌸 Browse Plants
          </button>
          <button className="ac-btn-outline" onClick={() => navigate('/design')}>
            ✏️ Design Containers
          </button>
        </div>
      )}

      {hasContent && (
        <div className="text-center space-y-2 pt-4 border-t-2 border-dashed border-ac-bg">
          <p className="font-body text-xs text-ac-brown-light">
            Happy gardening! 🌱 Remember: container plants need more frequent watering than ground gardens.
          </p>
          <button
            className="font-body text-xs text-ac-green underline decoration-dotted hover:text-ac-green-dark"
            onClick={() => navigate('/design')}
          >
            ← Back to Container Design
          </button>
        </div>
      )}
    </div>
  )
}
